import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createSpecialization = createAsyncThunk(
  "specialization/createSpecialization",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/specialization/createSpecialization",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const getAllSpecialization = createAsyncThunk(
  "specialization/getSpecialization",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.post("/specialization/getSpecialization",
        serchingFor,
        {
          headers: {
            "Content-Type": "application/json",
            token: serchingFor.token
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const updateSpecialization = createAsyncThunk(
  "specialization/editSpecializations",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/specialization/editSpecializations",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const deleteSpecialization = createAsyncThunk(
  "specialization/deleteSpecialization",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/specialization/deleteSpecialization",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

const initialState = {
  specializations: [],
  error: null,
  isLoading: false,
  createSpecializationSuccessMessage: null,
  createSpecializationErrorMessage: null,
  updateSpecializationSuccessMessage: null,
  updateSpecializationErrorMessage: null,
  deleteSpecializationSuccessMessage: null,
  deleteSpecializationErrorMessage: null,
};

const specializationSlice = createSlice({
  name: "specialization",
  initialState,
  reducers: {
    resetCreateMessages: (state) => {
      state.createSpecializationSuccessMessage = null;
      state.createSpecializationErrorMessage = null;
    },
    resetUpdateMessages: (state) => {
      state.updateSpecializationSuccessMessage = null;
      state.updateSpecializationErrorMessage = null;
    },
    resetDeleteMessages: (state) => {
      state.deleteSpecializationSuccessMessage = null;
      state.deleteSpecializationErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createSpecialization.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createSpecialization.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.createSpecializationErrorMessage =
            action.payload.result.message;
        } else {
          state.createSpecializationSuccessMessage =
            action.payload.result.message;
        }
      })
      .addCase(createSpecialization.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getAllSpecialization.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllSpecialization.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchMessage = action.payload.result.message;
        }
        state.specializations = action.payload.result.list;
      })
      .addCase(getAllSpecialization.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateSpecialization.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateSpecialization.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === true) {
          state.updateSpecializationSuccessMessage =
            action.payload.result.message;
        } else {
          state.updateSpecializationErrorMessage =
            action.payload.result.message;
        }
      })
      .addCase(updateSpecialization.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deleteSpecialization.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteSpecialization.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === true) {
          state.deleteSpecializationSuccessMessage =
            action.payload.result.message;
        } else {
          state.deleteSpecializationErrorMessage =
            action.payload.result.message;
        }
      })
      .addCase(deleteSpecialization.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export const { resetCreateMessages, resetDeleteMessages, resetUpdateMessages } =
  specializationSlice.actions;
export default specializationSlice.reducer;
